'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var SubscriptionModalLayout = require('modules/settings/views/layout/subscription/modal');
var CreditCardFormView = require('modules/settings/views/partials/subscription/creditcard');
var CreditCardModel = require('modules/settings/models/creditcard');

var templateDisplay = require('modules/settings/templates/partials/subscription/payment-method-display.hbs');
var templateEdit = require('modules/settings/templates/partials/subscription/payment-method-edit.hbs');

var SubscriptionPaymentMethodView = LayoutView.extend({
    getTemplate: function(){
        return this.getOption('mode') === 'edit' ? templateEdit : templateDisplay;
    },

    className: function() {
        var classes = [
            'braintree-payment-container',
            this.getOption('mode') === 'edit' ? 'subscription-payment-method-edit' : 'subscription-payment-method-display',
        ];

        return classes.join(' ');
    },

    ui: {
        braintreeContainer: '.braintree-payment-container',
        editButton: '[data-action="edit"]',
    },

    events: {
        // 'click @ui.cancelSubscription': 'cancelSubscription',
        'click @ui.editButton': 'openEditModal',
        'click #braintree-paypal-button': 'preventPaypalClick',
    },

    childEvents: {
        'creditcardProvided': 'generateCreditcardNonce',
    },

    regions: {
        creditcardRegion: '.payment-method-creditcard',
    },

    isSetup: false,

    mode: 'display',

    onShow: function() {
        if (this.getOption('mode') === 'edit') {
            this.creditcardRegion.show(new CreditCardFormView({
                model: new CreditCardModel(),
                isSetup: this.getOption('isSetup'),
            }));

            this.loadBraintree();
        }
    },

    onSubmit: function() {
        this.creditcardRegion.currentView.triggerMethod('submit');
    },

    generateCreditcardNonce: function(view, model) {
        var client = new braintree.api.Client({clientToken: this.model.get('braintreeToken')});

        client.tokenizeCard({
            number: model.get('cardNumber'),
            cardholderName: model.get('cardHolder'),
            expirationDate: model.get('cardExpires'),
            cvv: model.get('cardCvv'),
        }, function (err, nonce) {
            if (err) {
                return console.log(err);
            }

            this.save({
                type: 'creditcard',
                nonce: nonce,
                info: model.get('cardNumber').substr(-4),
                expires: model.get('cardExpires'),
                cardType: model.get('cardType'),
            });
        }.bind(this));

        // Show loading
        this.triggerMethod('saving');
    },

    /**
     * Includes the braintree JS Api
     */
    loadBraintree: function() {
        if (!window.braintree) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = 'https://js.braintreegateway.com/v2/braintree.js';
            script.addEventListener('load', function(event) {
                this.initBraintree();
            }.bind(this));

            document.body.appendChild(script);
        } else {
            this.initBraintree();
        }
    },

    /**
     * Is triggered, when braintree is loaded
     */
    initBraintree: function() {
        if (this.$('#paypal-container').length > 0) {
            braintree.setup(this.model.get('braintreeToken'), 'custom', {
                onReady: this.onBraintreeReady.bind(this),
                onError: this.onBraintreeError.bind(this),
                paypal: {
                    container: 'paypal-container',
                    singleUse: false,
                    //amount: 10.00, // TBD: Check if needed
                    //currency: 'EUR', // TDB: Check if needed
                    onSuccess: this.onBraintreeReceivedPaypalAccount.bind(this),
                    onCancelled: this.onBraintreeCancelledPaypal.bind(this),
                },
            });
        }
    },

    /**
     * Is called, when Braintree is ready to use
     */
    onBraintreeReady: function() {
        if (this.isDestroyed) { return; }

        this.triggerMethod('readyToSave');
        this.$el.addClass('is-ready');
    },

    /**
     * Is called, when we received a PayPal account from Braintree
     * @param {string} nonce The payment nonce
     * @param {string} email The user's email
     */
    onBraintreeReceivedPaypalAccount: function(nonce, email) {
        if (this.isDestroyed) { return; } //this can be removed if braintree finally gets a destructor function.

        // Show loading
        this.triggerMethod('saving');

        this.save({
            type: 'paypal',
            nonce: nonce,
            info: email,
        });
    },

    /**
     * Is triggered, when the user cancels the paypal account
     */
    onBraintreeCancelledPaypal: function() {
        if (this.isDestroyed) { return; }

        // console.info('User cancelled');
    },

    /**
     * Is triggered, when there is an error at Braintree
     * @param {object} error The error object
     */
    onBraintreeError: function(error) {
        if (this.isDestroyed) { return; }

        // console.warn('ERROR', error);
    },

    /**
     * Is triggered, when a Nonce is received from creditcard or paypal
     * @param {string} nonce   The payment nonce
     * @param {string} type    The type CreditCard | PayPal
     * @param {object} payload Additional data from the braintree response
     */
    save: function(data) {
        data = {
            setupStep: this.getOption('isSetup') ? this.model.get('setupStep') + 1 : this.model.get('setupStep'),
            paymentMethod: data,
        };

        //@todo show loading spinner

        this.model.save(data, {
            patch: true,
            wait: true,
            success: function() {
                this.triggerMethod('saved', data);
            }.bind(this),
            error: function(model, response) {
                this.triggerMethod('save:error', response);
            }.bind(this),
        });
    },

    onSaving: function() {
        if (this.getOption('isSetup') !== true) {
            this.creditcardRegion.currentView.ui.saveButton.prop('disabled', true).addClass('is-loading');
        }
    },

    /**
     * Is triggered, when payment should be changed.
     * We will open a modal window
     * @param event
     */
    openEditModal: function(event) {
        App.addModal(new SubscriptionModalLayout({
            title: App.t('subscription::payment:modal:title'),
            bodyView: new SubscriptionPaymentMethodView({
                mode: 'edit',
                model: this.model,
            }),
        }), {
            additionalClassName: 'modal-subscription ' + (this.getOption('isSetup') ? 'modal-subscription-setup' : ''),
        });
    },

    onSaveError: function(response) {
        if (this.getOption('isSetup') !== true) {
            this.creditcardRegion.currentView.ui.saveButton.prop('disabled', false).removeClass('is-loading');
        }
    },

    /**
     * Since Braintree Paypal does not prevent default action, we have to prevent it
     * @param {object} event The click event
     * @see https://trello.com/c/jkNZNPAx/713-bug-paypal-not-working
     */
    preventPaypalClick: function(event) {
        event.preventDefault();
    },

});

module.exports = SubscriptionPaymentMethodView;